<div class="image-zoomer" *ngIf="show" (click)="close()">
  <div class="close">
    <mat-icon>close</mat-icon>
  </div>
  <app-loader [enable]="isLoading" [diameter]="30">
    <img [src]="imageUrl"
         (load)="hideLoader()"
         [ngClass]="{'image-loaded':!isLoading}"
    />
  </app-loader>
</div>
